module.exports = __webpack_public_path__ + "img/g9.36a610e1.jpeg";